module.exports = __webpack_public_path__ + "static/img/play.f9e9d92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.png
// module id = VZWR
// module chunks = 1